import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {SharedModule} from '@modules/shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';

// modules
import {AuthenticationRoutingModule} from './authentication-routing.module';
import {MaterialModule} from '../material/material.module';
// components
import {SignUpComponent} from './signup/signup.component';
import {AuthenticationWrapperComponent} from './authentication-wrapper/authentication-wrapper.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {AuthService} from '../../services/auth.service';
import {LoginComponent} from './login/login.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {UpdatePasswordComponent} from './update-password/update-password.component';
import {AuthGuard} from '../../services/auth.guard';

@NgModule({
  imports: [
    // angular
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    NgSelectModule,
    FontAwesomeModule,
    MaterialModule,
    // custom
    SharedModule,
    TranslateModule,
    AuthenticationRoutingModule,
  ],
  providers: [
    AuthService,
    AuthGuard
  ],
  declarations: [
    SignUpComponent,
    LoginComponent,
    AuthenticationWrapperComponent,
    ResetPasswordComponent,
    UpdatePasswordComponent
  ],
  exports: [
    LoginComponent,
    SignUpComponent,
    ResetPasswordComponent,
    UpdatePasswordComponent
  ]
})
export class AuthenticationModule {

}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/authentication.module.ts